import styled from 'styled-components';

interface SidebarContainerProps {
  isOpen: boolean;
}

export const SidebarContainer = styled.div<SidebarContainerProps>`
  position: fixed;
  top: 57.4px;
  right: ${({ isOpen }) => (isOpen ? '0' : '-600px')};
  width: 600px;
  height: calc(100vh - 57.4px);
  background-color: #ffffff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  z-index: 9999;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 100%;
    height: 80vh;
    top: auto;
    bottom: 0;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(100%)')};
    transition: transform 0.3s ease-in-out;
  }
`;

export const Dragger = styled.div`
  width: 36px;
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  margin: 12px auto;

  @media (min-width: 901px) {
    display: none;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 24px 16px 16px 32px;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 900px) {
    padding: 0px 16px 16px 24px;
  }
`;

export const SidebarTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #080e32;
  font-family: 'Helvetica Neue', sans-serif;
  line-height: 16px;
  letter-spacing: -0.01em;
`;

export const SidebarSubTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: #525252;
  font-family: 'Helvetica Neue', sans-serif;
  line-height: 16px;
  letter-spacing: -0.01em;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 60px;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;

  span {
    font-size: 24px;
  }

  &:hover {
    color: #333;
  }
`;

export const SidebarContent = styled.div`
  padding: 16px 32px 0 32px;
  flex: 1;
  overflow-y: auto;

  @media (max-width: 900px) {
    padding: 24px;
  }
`;

export const SidebarFooter = styled.div`
  padding: 16px 32px 32px 32px;
  border-top: 1px solid #e0e0e0;
  background-color: #ffffff;
  width: 100%;

  @media (max-width: 900px) {
    padding: 16px 24px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Backdrop = styled.div<SidebarContainerProps>`
  position: fixed;
  top: 57px;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  @media (max-width: 900px) {
    left: 0;
    top: 55px;
    width: 100vw;
    height: calc(100vh - 55px);
  }

  @media (max-width: 800px) {
    top: 0;
    height: 100vh;
  }
`;
